import { createFileRoute } from "@tanstack/react-router";

import { DefiProtocolsPage } from "../../features/defi/pages/defi-protocols-page";

export const Route = createFileRoute("/_layout/defi/protocols/")({
  component: DefiProtocolsPage,
});
